export default __webpack_public_path__ + "static/media/AboutSlide3.8c5b13b4.jpg";